{
  "info": "Informationen",
  "negative": "Fehler",
  "notice": "Warnung",
  "positive": "Erfolg"
}
